<template>
  <navigation-menu-item
    v-if="showSavingZone"
    title="חיסכון לטווח הארוך"
    target="saving-zone"
    :small="true"
    v-on:navigate="$emit('navigate')"/>
</template>

<script>
import NavigationMenuItem from '@/base-components/app-header/NavigationMenuItem';
import { mapState } from 'vuex';

export default {
  name: 'SavingZoneMenuItem',
  components: {
    NavigationMenuItem,
  },
  data() {
    return {
      showSavingZone: true,
    };
  },
  created() {
    this.showSavingZone = !this.registeredUsingHeverPromotion;
  },
  computed: {
    ...mapState('benefits', ['registeredUsingHeverPromotion']),
  },
};
</script>

<style scoped lang="scss">
</style>
